import type { AssetCatalogEntry } from '@buxus/shared'
import { catalogProductLabel } from './assetCatalogDisplay'

type AssetMapPreviewCardProps = {
  entry: AssetCatalogEntry
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}

/** Lower-left hover preview while browsing the map asset rail. */
export function AssetMapPreviewCard({
  entry,
  onMouseEnter,
  onMouseLeave,
}: AssetMapPreviewCardProps) {
  const product = catalogProductLabel(entry)

  return (
    <div
      className="asset-map-preview-card map-overlay-preview-card"
      role="region"
      aria-label={`Preview ${entry.displayName}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="map-overlay-preview-card-head">
        <p className="asset-map-preview-title">{entry.displayName}</p>
      </div>
      <div className="map-overlay-preview-card-body">
        {product ? (
          <p className="asset-map-preview-line">
            <span className="asset-map-preview-label">Products</span> {product}
          </p>
        ) : null}
        {entry.countiesLabel ? (
          <p className="asset-map-preview-line asset-map-preview-counties">{entry.countiesLabel}</p>
        ) : null}
      </div>
    </div>
  )
}
